export default function SessionExpiredModal({
  open,
  onRefresh,
  isRefreshing,
  title = "Session Expired",
  message = "Your search session has expired. Prices may have changed. Refresh results to continue.",
  buttonLabel = "Refresh",
  buttonLoadingLabel = "Refreshing...",
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-full max-w-sm text-center shadow-lg">
        <h2 className="text-xl font-semibold mb-3">{title}</h2>

        <p className="text-body font-sm text-foreground-muted mb-6">
          {message}
        </p>

        <button
          onClick={onRefresh}
          disabled={isRefreshing}
          className="px-6 py-3 bg-primary text-white rounded-lg w-full font-semibold hover:bg-primary-hover disabled:bg-gray-400 transition"
        >
          {isRefreshing ? buttonLoadingLabel : buttonLabel}
        </button>
      </div>
    </div>
  );
}
